import React from 'react';
import SearchFormCommon from '../search-components/SearchFormCommon';

const SearchMwe = () => (
  <SearchFormCommon type={'simple'}/>
);

export default SearchMwe;
